



















import { Component, Vue } from 'vue-property-decorator';
import FlexButton from '@/components/button/FlexButton.vue';
import { signUpScheme } from '@/utils/scheme';
import { namespace } from 'vuex-class';

const userModule = namespace('user');

@Component({
  components: {
    FlexButton
  }
})
export default class ContactFooter extends Vue {
  @userModule.Getter
  requesterId!: string;

  buttonsList = [
    {
      text: '1:1 문의하기',
      color: 'white',
      style: {
        height: '48px'
      }
    }
  ];
  showPhone = false;

  created() {
    if (sessionStorage.getItem('access_token')) {
      this.showPhone = true;
    }
  }

  async handleClick() {
    if (!sessionStorage.getItem('access_token')) {
      signUpScheme();
    } else {
      this.$router.push({
        name: 'ticket-create'
      });
    }
  }
}
